module.exports = __webpack_public_path__ + "img/logo-denplan.8744f66b.svg";